import { Icon } from '@mui/material'
import './AboutusPageNew.css'
import missionVissionImg from './image/about_us_mission_vission.png'

import AboutUsCRCard from './comp/AboutUsCRCard';
import { FaHandshake } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";
import { FaCalendarAlt } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { FaBagShopping } from "react-icons/fa6";
import { FaMusic } from "react-icons/fa6";
import { HiUsers } from "react-icons/hi2";
import { FaBuilding } from "react-icons/fa";

import { FaClock } from "react-icons/fa";
import { FaCheckCircle } from "react-icons/fa";
import { PiSquaresFour } from "react-icons/pi";
import { FaDollarSign } from "react-icons/fa";
import { TfiHeadphoneAlt } from "react-icons/tfi";


import AboutUsBuildForCard from './comp/AboutUsBuildForCard';
import AboutWCPartyWittyCard from './comp/AboutWCPartyWittyCard';


const whatWeOfferData = [
    {
        stepNumber: "01",
        title: "Corporate Recreation",
        subtitle: "Engage employees with amazing events",
        Icon: FaBagShopping,
    },
    {
        stepNumber: "02",
        title: "Artists & Entertainment",
        subtitle: "Book talented performers and entertainers",
        Icon: FaMusic,
    },
    {
        stepNumber: "03",
        title: "Vendor Partnerships",
        subtitle: "Connect with verified service providers",
        Icon: FaHandshake,
    },
    {
        stepNumber: "04",
        title: "Discover & Book Venues",
        subtitle: "Find and book top venues across India",
        Icon: FaLocationDot,
    },
    {
        stepNumber: "05",
        title: "Custom Party Packages",
        subtitle: "Create personalized party experiences",
        Icon: FaCalendarAlt,
    },
    {
        stepNumber: "06",
        title: "Table Booking with Perks",
        subtitle: "Exclusive benefits with every reservation",
        Icon: FaUsers,
    }

]


const buildForData = [
    {
        Icon: HiUsers,
        title: "Party-Goers",
        subtitle: "Discover amazing venues and experiences across the city"
    },
    {
        Icon: HiUsers,
        title: "Hosts & Organizers",
        subtitle: "Plan stress-free events with our comprehensive platform"
    },
    {
        Icon: FaBuilding,
        title: "Corporates & HRs",
        subtitle: "Boost employee engagement with our recreation programs"
    },
    {
        Icon: FaHandshake,
        title: "Clubs & Vendors",
        subtitle: "Grow your business with our tech-driven marketplace"
    },
]

const whyChoosePartywittyData = [
    {
        Icon: FaClock,
        title: "Party-Goers",
        subtitle: "Discover amazing venues and experiences across the city"
    },
    {
        Icon: FaCheckCircle,
        title: "Hosts & Organizers",
        subtitle: "Plan stress-free events with our comprehensive platform"
    },
    {
        Icon: PiSquaresFour,
        title: "Corporates & HRs",
        subtitle: "Boost employee engagement with our recreation programs"
    },
    {
        Icon: FaDollarSign,
        title: "Clubs & Vendors",
        subtitle: "Grow your business with our tech-driven marketplace"
    },
    {
        Icon: TfiHeadphoneAlt,
        title: "Clubs & Vendors",
        subtitle: "Grow your business with our tech-driven marketplace"
    }
]



export default function AboutusPageNew() {
    return (
        <>
            <div className='about-us-new-page'>
                <div className='about-us-new-container'>
                    <div className='about-us-new-wrapper'>

                        <div className='about-us-new-banner-section'>
                            <div className='about-us-new-banner-img'>
                                <img src="https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="" />
                                <div className='about-us-new-banner-overlay'>
                                    <div className='aunt-us-new-title'>
                                        <p>India's First Party-Tech Platform</p>
                                    </div>
                                    <h1>Built for the Way You Celebrate</h1>
                                    <p>At PartyWitty, we believe party planning should be as fun as the party itself.</p>
                                    <div className='aunt-us-new-button'>
                                        <button>Start Planning Now</button>
                                        <button>Watch Demo</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='about-us-new-content-what-we-are-section'>
                            <h1>What We Offer</h1>
                            <p>Everything you need to plan, book, and celebrate like never bef ore</p>
                            <div className='about-us-new-content-what-we-are-section-cards'>
                                {whatWeOfferData.map(({ stepNumber, title, subtitle, Icon }) => (
                                    <AboutUsCRCard stepNumber={stepNumber} title={title} subtitle={subtitle} Icon={Icon} />
                                ))}
                            </div>
                        </div>

                        <div className='about-us-new-content-mission-vission'>

                            <div className='about-us-new-content-mission-vission-text'>
                                <h1>Our Mission</h1>
                                <p>To simplify party planning and make premium nightlife experiences accessible and stress-free for everyone across India.</p>
                                <br />
                                <p>We're democratizing celebrations by removing barriers between party-goers and amazing experiences.</p>
                            </div>
                            <div className='about-us-new-content-mission-vission-img'>
                                <img src={missionVissionImg} alt="" />
                            </div>
                        </div>

                        <div className='about-us-new-content-mission-vission'>
                            <div className='about-us-new-content-mission-vission-img'>
                                <img src={missionVissionImg} alt="" />
                            </div>
                            <div className='about-us-new-content-mission-vission-text'>
                                <h1>Our Vision</h1>
                                <p>To become India's leading tech-driven celebration platform, connecting millions of party enthusiasts with unforgettable experiences.</p>
                                <br />
                                <p>We envision a future where every celebration is perfectly planned and executed with just a few taps.</p>
                            </div>

                        </div>

                        {/* build for  */}
                        <div className='about-us-new-build-for-section'>
                            <h1>Who We're Built For</h1>
                            <p>From party enthusiasts to business owners, we've got everyone covered</p>

                            <div className='about-us-new-build-for-section-cards'>
                                {buildForData.map(({ Icon, title, subtitle }) => (
                                    <AboutUsBuildForCard Icon={Icon} title={title} subtitle={subtitle} />
                                ))}
                            </div>
                        </div>

                        {/* why choose partywitty */}
                        <div className='about-us-new-why-choose-partywitty-section'>
                            <h1>Why Choose <span className='aunwc-partywitty-section-span'>PartyWitty</span>?</h1>
                            <div className='about-us-new-why-choose-partywitty-section-cards'>
                                {whyChoosePartywittyData.map(({ Icon, title, subtitle }) => (
                                    <AboutWCPartyWittyCard Icon={Icon} title={title} subtitle={subtitle} />
                                ))}
                            </div>
                        </div>

                        {/* Join the Party Movement */}
                        <div className='about-us-new-join-party-movement-section'>
                            <h1>Join the Party Movement</h1>
                            <p>Thousands of successful bookings and a growing network spanning Delhi NCR.
                                <br /> We're making nightlife more inclusive, efficient, and fun for everyone.</p>

                                <div className='about-us-new-join-party-movement-section-button'>
                                    <div className='aunjpmsb-wrapper'>
                                        <h1>5000+</h1>
                                        <p>Happy Customers</p>
                                    </div>
                                    <div className='aunjpmsb-wrapper'>
                                        <h1>200+</h1>
                                        <p>Partner Venues</p>
                                    </div>
                                    <div className='aunjpmsb-wrapper'>
                                        <h1>50+</h1>
                                        <p>Cities Growing Soon</p>
                                    </div>
                                </div>

                                <button className='aunjpmsb-button'>Join Partywitty Today</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
